/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	DateTime: `scalar.DateTime` as const,
	AccountStatus: "enum" as const,
	Thematique: "enum" as const,
	Site: "enum" as const,
	ActivityType: "enum" as const,
	Query:{
		getRole:{

		},
		getPermission:{

		},
		getConfig:{

		},
		getMail:{

		},
		loginAsGuest:{

		},
		login:{

		},
		uniqueAuthFromSso:{

		},
		getUser:{

		},
		getFilteredUsers:{
			findManyUserWithFiltersInput:"FindManyUserWithFiltersInput"
		},
		downloadFile:{

		},
		countOfConnectionsPerDay:{
			findConnectionsPerDayInput:"FindConnectionsPerDayInput"
		},
		getFilteredTrackingThematiques:{
			filterTrackingThematiqueInput:"FilterTrackingThematiqueInput"
		},
		getStats:{
			filterStatsInput:"FilterStatsInput"
		},
		getCommonStats:{
			filterStatsInput:"FilterStatsInput"
		}
	},
	EError: "enum" as const,
	FindManyUserWithFiltersInput:{
		orderBy:"UserOrderByInput",
		filterBy:"UserFilterByInput"
	},
	UserOrderByInput:{
		email:"OrderByEnum",
		firstName:"OrderByEnum",
		lastName:"OrderByEnum",
		lastConnectionAt:"OrderByEnum",
		role:"OrderByEnum"
	},
	OrderByEnum: "enum" as const,
	UserFilterByInput:{

	},
	FindConnectionsPerDayInput:{
		startDate:"DateTime",
		endDate:"DateTime"
	},
	FilterTrackingThematiqueInput:{
		thematique:"Thematique",
		startDate:"DateTime",
		endDate:"DateTime"
	},
	FilterStatsInput:{
		startDate:"DateTime",
		endDate:"DateTime"
	},
	Mutation:{
		askForResetPassword:{

		},
		resetPassword:{

		},
		verifyEmail:{

		},
		register:{

		},
		askForRegister:{
			registerUserInput:"RegisterUserInput"
		},
		finishRegister:{

		},
		finishRegisterAsGuest:{

		},
		createUser:{
			createUserInput:"CreateUserInput"
		},
		updateUser:{
			updateUserInput:"UpdateUserInput"
		},
		deleteUser:{

		},
		deleteFile:{

		},
		uploadPreSignedUrl:{

		},
		confirmUpload:{

		},
		createConnection:{
			createConnectionInput:"CreateConnectionInput"
		},
		createTracking:{
			createTrackingInput:"CreateTrackingInput"
		},
		createOrUpdateTrackingThematique:{
			createTrackingThematiqueInput:"CreateTrackingThematiqueInput"
		},
		updateTrackingThematique:{
			updateTrackingThematiqueInput:"UpdateTrackingThematiqueInput"
		}
	},
	RegisterUserInput:{

	},
	CreateUserInput:{

	},
	UpdateUserInput:{

	},
	CreateConnectionInput:{

	},
	CreateTrackingInput:{
		activityType:"ActivityType"
	},
	CreateTrackingThematiqueInput:{
		site:"Site",
		thematique:"Thematique"
	},
	UpdateTrackingThematiqueInput:{
		terminatedAt:"DateTime"
	}
}

export const ReturnTypes: Record<string,any> = {
	Health:{
		env:"String",
		time:"String",
		status:"String"
	},
	Permissions:{
		id:"Int",
		uuid:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		roles:"Roles"
	},
	DateTime: `scalar.DateTime` as const,
	Users:{
		id:"Int",
		uuid:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		status:"AccountStatus",
		email:"String",
		password:"String",
		passwordResetToken:"String",
		passwordResetExpiryDate:"DateTime",
		activateAccountToken:"String",
		activateAccountExpiryDate:"DateTime",
		emailVerified:"Boolean",
		verifyEmailToken:"String",
		verifyEmailExpiryDate:"DateTime",
		firstName:"String",
		lastName:"String",
		refreshToken:"String",
		role:"Roles",
		roleId:"Int"
	},
	UserPagination:{
		users:"Users",
		total:"Int"
	},
	Roles:{
		id:"Int",
		uuid:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		permissions:"Permissions",
		users:"Users"
	},
	UniqueAuth:{
		access_token:"String",
		firstName:"String",
		lastName:"String",
		role:"String",
		email:"String"
	},
	Configs:{
		id:"Int",
		uuid:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		key:"String",
		value:"String"
	},
	Connection:{
		id:"Int",
		createdAt:"DateTime",
		sessionUuid:"String"
	},
	ConnectionsPerDay:{
		day:"DateTime",
		count:"Int"
	},
	DownloadFile:{
		fileName:"String",
		fileMimeType:"String",
		buffer:"String"
	},
	MyFiles:{
		eTag:"String",
		location:"String",
		fileName:"String",
		fileMimeType:"String",
		createdAt:"DateTime",
		ownerId:"Int"
	},
	UploadPreSignedUrl:{
		url:"String",
		id:"Int"
	},
	Mail:{
		id:"Int",
		uuid:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		key:"String",
		to:"String",
		data:"String"
	},
	TrackingThematique:{
		id:"Int",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		terminatedAt:"DateTime",
		thematique:"Thematique",
		site:"Site",
		currentActivityOrder:"Int",
		time:"Int",
		connection:"Connection",
		connectionId:"Int",
		trackings:"Tracking"
	},
	TrackingThematiqueInfo:{
		id:"Int",
		terminatedAt:"DateTime",
		thematique:"Thematique",
		site:"Site",
		currentActivityOrder:"Int",
		time:"Int",
		connection:"Connection",
		connectionId:"Int",
		trackings:"TrackingInfo"
	},
	TrackingThematiquePagination:{
		trackings:"TrackingThematique",
		total:"Int"
	},
	TrackingPassedTimeByThematique:{
		thematique:"Thematique",
		site:"Site",
		passedTime:"Int",
		viewCount:"Int",
		viewCountFinished:"Int",
		viewCountLeft:"Int",
		questionCount:"Int",
		questionCountCorrect:"Int",
		questionCountIncorrect:"Int",
		responses:"Response"
	},
	Response:{
		activityOrder:"Int",
		questionCountCorrect:"Int",
		questionCountIncorrect:"Int"
	},
	RushHour:{
		hour:"Int",
		count:"Int"
	},
	SiteRushHour:{
		site:"String",
		rushHours:"RushHour"
	},
	TrackingsStats:{
		connectionCount:"Int",
		passedTime:"Int",
		trackingsByThematique:"TrackingPassedTimeByThematique",
		siteRushHour:"SiteRushHour"
	},
	TrackingsCommonStats:{
		connectionCount:"Int",
		passedTime:"Int",
		siteRushHour:"SiteRushHour"
	},
	Tracking:{
		id:"Int",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		isCorrect:"Boolean",
		activityOrder:"Int",
		activityType:"ActivityType",
		answers:"String",
		time:"Int",
		trackingThematique:"TrackingThematique",
		trackingThematiqueId:"Int"
	},
	TrackingInfo:{
		id:"Int",
		isCorrect:"Boolean",
		activityOrder:"Int",
		activityType:"ActivityType",
		answers:"String",
		time:"Int",
		trackingThematiqueId:"Int"
	},
	Query:{
		getHealthGql:"Health",
		getRole:"Roles",
		getRoles:"Roles",
		getPermission:"Permissions",
		getPermissions:"Permissions",
		getConfig:"Configs",
		getConfigs:"Configs",
		getMail:"Mail",
		getMails:"Mail",
		sendMail:"Boolean",
		loginAsGuest:"AuthType",
		login:"AuthType",
		uniqueAuthFromSso:"UniqueAuth",
		getUser:"Users",
		getUsers:"Users",
		getFilteredUsers:"UserPagination",
		downloadFile:"DownloadFile",
		getAllMyFiles:"MyFiles",
		countOfConnectionsPerDay:"ConnectionsPerDay",
		getTrackings:"Tracking",
		getFilteredTrackingThematiques:"TrackingThematiquePagination",
		getStats:"TrackingsStats",
		getCommonStats:"TrackingsCommonStats"
	},
	AuthType:{
		"...on Tokens":"Tokens",
		"...on CustomError":"CustomError"
	},
	Tokens:{
		access_token:"String",
		refresh_token:"String"
	},
	CustomError:{
		error:"EError",
		message:"String"
	},
	Mutation:{
		askForResetPassword:"Boolean",
		resetPassword:"Boolean",
		verifyEmail:"Boolean",
		register:"AuthType",
		askForRegister:"Boolean",
		finishRegister:"Boolean",
		finishRegisterAsGuest:"Boolean",
		refresh:"AuthType",
		logout:"Boolean",
		createUser:"Users",
		updateUser:"Users",
		deleteUser:"Boolean",
		deleteFile:"Boolean",
		uploadPreSignedUrl:"UploadPreSignedUrl",
		confirmUpload:"Boolean",
		createConnection:"Connection",
		createTracking:"TrackingInfo",
		createOrUpdateTrackingThematique:"TrackingThematiqueInfo",
		updateTrackingThematique:"Boolean"
	}
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const
}